import { css } from '@emotion/react';
import { Alert, Box, Card, Stack, Typography } from '@mui/material';
import { BasicDialog } from '../../../../../components/Dialog/BasicDialog';
import { FormFieldsContainer } from '../../../../../components/Form/FormComponents';
import { StickyFormButtons } from '../../../../../components/Form/StickyFormButtons';
import { CompanyLogoAndName } from '../../../../../components/grid-renderers/CompanyCellRenderer';
import { cardStyles } from '../../../../../theme/component-styles';
import { FMT } from '../../../../../util/formatter-service';
import { InfoBox } from '../../../../Mappings/forms/InfoBox';
import { useClearTemplatesModal } from './useClearTemplatesModal';

const dialogContentCss = css`
  padding-bottom: 0;
  gap: 0.5rem;
`;

const companyCardCss = css({
  ...cardStyles,
  marginBottom: '0.25rem',
  display: 'grid',
  gridTemplateColumns: '1fr 2fr',
  columnGap: '1rem',
  alignItems: 'center',
});

export function ClearTemplatesModal() {
  const { isOpen, loading, companiesWithTemplates, handleClose, handleConfirm } = useClearTemplatesModal();

  if (!isOpen) {
    return null;
  }

  return (
    <BasicDialog title='Clear Template Assignments?' open onClose={handleClose}>
      <FormFieldsContainer css={dialogContentCss}>
        <Stack display='grid' gridTemplateRows='1fr auto' gap='1rem'>
          {companiesWithTemplates.length === 0 ? (
            <Alert severity='warning'>None of the selected companies have custom template assignments.</Alert>
          ) : (
            <>
              <Box maxHeight='25rem' sx={{ overflowY: 'auto' }}>
                {companiesWithTemplates.map((company) => {
                  const templateNames = company.templateUuids
                    .map((uuid) => FMT.format('kpiTemplateName', uuid))
                    .join(', ');
                  return (
                    <Card css={companyCardCss} key={company.id}>
                      <CompanyLogoAndName name={company.name} logoUrl={company.logoUrl ?? ''} />
                      <Typography variant='body2' color='text.secondary'>
                        {templateNames}
                      </Typography>
                    </Card>
                  );
                })}
              </Box>
              <InfoBox message='Custom template assignments will be removed. These companies will receive Universal KPI requests only.' />
            </>
          )}
        </Stack>
      </FormFieldsContainer>
      <StickyFormButtons
        onSubmit={handleConfirm}
        loading={loading}
        disabled={companiesWithTemplates.length === 0}
        onCancel={handleClose}
        submitLabel='Clear Templates'
        style={{ paddingTop: '1rem' }}
      />
    </BasicDialog>
  );
}
